import React, { useState, useEffect, useRef, forwardRef } from "react";
import { secondaryButtonTheme, primaryButtonTheme, fontRegular, fontBold, fontMedium, liStyle, bottomDivStyle, errorMsgStyle, divBgStyle, inputStyle, popupStyle } from '../../utils/AppStyle';
import { selectBankHint, selectedBankHint, bankErr, termsTitle, statusCodeUserCancelled, btnCancel } from "../../utils/Strings";
import { getBankIconPath, getSearchIconPath, getDropDownIconPath, getCloseIconPath, getUserActionBtnStyle, userActionBtnStyleText, homeInputStyleIcon, getHomeInputStyle, getHomePrimaryBtnText, getTCText, getBankLogo } from '../../Config';
import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";
import Terms from "../include/Terms";
import { getInstitutionList } from "../../utils/NetworkUtil";
import { isNullOrEmpty } from "../../utils/AppUtil";
import CustomDropdown from "../../utils/CustomDropdown";
import { PopUp } from "../../utils/PopUp";
import ReactHtmlParser from 'react-html-parser';
import { default as ReactSelect } from "react-select";
import { Option } from "../../utils/Option";

const StmtUploadHome = () => {

    let history = useHistory();
    const [institutionId, setInstitutionId] = useState(sessionStorage.getItem('institution_id'));
    const [selectedBankId, setSelectedBankId] = useState([]);
    const [institutionIdGiven, setInstitutionIdGiven] = useState(sessionStorage.getItem('institution_id_given'));
    const [bankList, setBankList] = useState([]);
    const [bankLabelList, setBankLabelList] = useState([]);
    const [txnId, setTxnId] = useState(sessionStorage.getItem('txn_id'));
    const [bankHint, setBankHint] = useState(selectBankHint);
    const [bankName, setBankName] = useState("primary");
    const [bankCode, setBankCode] = useState("");
    const [showTc, setShowTc] = useState(false);
    const [isBankError, setBankError] = useState(false);
    const [noOfMonths, setNoOfMonths] = useState(sessionStorage.getItem('no_of_months'));
    const [startMonth, setStartMonth] = useState(sessionStorage.getItem('start_month'));
    const [endMonth, setEndMonth] = useState(sessionStorage.getItem('end_month'));
    const [note, setNote] = useState("");
    const [msgText, setMsgText] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [pdfApplicable, setPdfApplicable] = useState(false);
    const [bankSelectionEnabled, setBankSelectionEnabled] = useState((!isNullOrEmpty(localStorage.getItem("bank_selection_enabled"))) ? localStorage.getItem("bank_selection_enabled") : "1");

    const selectRef = useRef(null);

    useEffect(() => {
        if (selectRef.current) {
            selectRef.current.focus();
        }
    }, [selectedBankId]);

    useEffect(() => {

        if (institutionIdGiven == "true") {
            setBankHint(selectedBankHint);
        }
        else {
            setBankHint(selectBankHint);
        }

        /* Getting the bank list for dropdown */

        const institutionListCb = (response) => {
            let bankData = [];
            var bankLabels = [];
            let resData = response.data.data;
            for (let i = 0; i < resData.length; i++) {
                bankData.push({
                    "id": resData[i].id,
                    "name": resData[i].name,
                    "username_text": resData[i].username_text,
                    "display_name": resData[i].display_name,
                    "msg_text": resData[i].msg_text,
                    "is_pdf_applicable": resData[i].is_pdf_applicable,
                    "code": resData[i].code
                });
                bankLabels.push({ value: resData[i].id, label: resData[i].name, bankCode: resData[i].code })
            }
            setBankList(bankData);
            setBankLabelList(bankLabels);

            bankData.findIndex((item) => {
                if (item.id == institutionId) {
                    setInstitutionId(institutionId);
                    setBankName(item.name);
                    setBankCode(item.code);
                    setNote(item.display_name);
                    setMsgText(item.msg_text);
                    setPdfApplicable(item.is_pdf_applicable);
                    sessionStorage.setItem("bank_name", item.name);
                }
            })

            //saveAnalyticsEvent("shown", "");
        }

        if ((bankSelectionEnabled == "1") || (institutionIdGiven == "true")) {
            getInstitutionList(history, institutionListCb);
        }
    }, []);

    const handleBankSelect = (event) => {
        let institution_id = event.target.value;
        setInstitutionId(institution_id);
        if (institution_id != -1) {
            setBankError(false);
            bankList.findIndex((item) => {
                if (item.id == institution_id) {
                    sessionStorage.setItem('institution_id', institution_id);
                    sessionStorage.setItem("bank_name", item.name);
                    setBankName(item.name);
                    setBankCode(item.code);
                    setNote(item.display_name);
                    setMsgText(item.msg_text);
                    setPdfApplicable(item.is_pdf_applicable);
                }
            })
        }
        else {
            setNote("");
        }
    }

    const showTcFunc = () => {
        setShowTc(true);
    }

    const hideTcFunc = () => {
        setShowTc(false);
    }

    const handlePopupClose = () => {
        setShowPopup(false);
    }

    const handleNext = () => {
        if ((institutionId != -1) || (bankSelectionEnabled == "0")) {
            if ((!isNullOrEmpty(msgText)) && (pdfApplicable == true)) {
                setShowPopup(true);
            }
            else {
                history.push('/pdfupload');
            }
        }
        else {
            setBankError(true);
        }
    }

    const handleConfirm = () => {
        localStorage.setItem("statement_list", "");
        history.push('/pdfupload');
    }

    const handleCancel = () => {
        sessionStorage.setItem('status_code', statusCodeUserCancelled);
        sessionStorage.setItem('status', false);
        history.push("/txncomplete");
    }

    const handleStatementBankSelect = (selected) => {
        // let institution_id = e.target.value;
        setSelectedBankId(selected);
        let institution_id = selected?.value;
        if (!isNullOrEmpty(institution_id) && institution_id != -1) {
            setInstitutionId(institution_id);
            setBankError(false);
            bankList.findIndex((item) => {
                if (item.id == institution_id) {
                    sessionStorage.setItem('institution_id', institution_id);
                    sessionStorage.setItem("bank_name", item.name);
                    setBankName(item.name);
                    setBankCode(item.code);
                    setNote(item.display_name);
                    setMsgText(item.msg_text);
                    setPdfApplicable(item.is_pdf_applicable);
                }
            })
        }
        else {
            setInstitutionId(-1);
            setNote("");
        }
    }

    // const CustomOption = (props) => {
    //     const { innerProps, data, isSelected, isFocused } = props;

    //     return (
    //         <Option innerProps={innerProps} data={data} isSelected={isSelected} isFocused={isFocused}/>
    //     );
    // };

    const CustomOption = (props) => {
        const { innerRef, innerProps, isFocused, isSelected } = props;

        useEffect(() => {
            if (isFocused && innerRef?.current) {
                innerRef.current.scrollIntoView({
                    block: 'nearest',
                    behavior: 'smooth',
                });
            }
        }, [isFocused, innerRef]);

        return (
            <div
                ref={innerRef}
                {...innerProps}
                className="custom-option"
                style={{
                    backgroundColor: isFocused ? '#f0f0f0' : 'white',
                    color: isSelected ? '#212121' : '#000',
                    cursor: 'pointer',
                }}
            >
                <img className="bank-logo" src={getBankLogo(props.data.bankCode)} />
                <span className="select-checkbox-label" style={fontMedium}>{props.data.label}</span>

            </div>
        );
    };


    const CustomControl = forwardRef(({ children, innerRef, innerProps, ...props }, ref) => {
        // const handleControlClick = () => {
        //     console.log("abc")
        //     // Find the input field within the 'custom-control' div
        //     const inputField = document.getElementById('custom-control')?.querySelector('input');
        //     // Focus on the input field if found
        //     inputField && inputField.focus();
        // };

        const handleKeyPress = (event) => {
            const keyCode = event.keyCode || event.which;

            // Allow letters and some special characters like space (key codes: 65-90, 97-122, 32)
            if ((keyCode < 65 || keyCode > 90) && (keyCode < 97 || keyCode > 122) && keyCode !== 32) {
                event.preventDefault();
                console.log('Please enter only letters.');
            }
        };

        return (
            <div
                id='custom-control'
                className="custom-control"
                tabIndex={0}
                //onClick={handleControlClick}
                onKeyPress={handleKeyPress}
                // Spread innerProps here to allow ReactSelect to handle the menu opening
                {...innerProps}
                style={{ display: 'flex', alignItems: 'center', backgroundColor: '#004C8F1A', borderRadius: '5px' }}
            >
                <span>
                    <img src={getSearchIconPath()} style={{ width: '15px', height: 'auto' }} />
                </span>
                {children}
            </div>
        );
    });

    return (
        <div>
            <div className="action-card">
                <div>
                    <div>
                        <div>
                            <div className="card-action-title" style={fontBold}>Upload Bank PDF Statement</div>

                            <div style={{ paddingTop: '10px' }}>
                                {
                                    (institutionIdGiven === "true") ?
                                        (bankList.length > 0) ?
                                            <div style={divBgStyle} className="bank-name-div">
                                                <img className="bank-logo" src={getBankLogo(bankCode)} />
                                                <span className="bank-name" style={fontMedium}>{bankName}</span>
                                            </div> : <></>
                                        :
                                        (bankSelectionEnabled == "1") ?
                                            (getHomeInputStyle() == homeInputStyleIcon) ?
                                                <div>
                                                    <div>
                                                        <img src={getBankIconPath()} className="homeIcon" alt="bank" />
                                                        <span className="homeTextFieldTitle" style={(isBankError === true) ? errorMsgStyle : fontMedium}>{bankHint}</span>
                                                    </div>

                                                    <div style={{ marginTop: '10px', height: '50px' }}>
                                                        <ReactSelect
                                                            id="fip_menu"
                                                            className="custom-react-select"
                                                            placeholder="search specific bank"
                                                            options={bankLabelList}
                                                            isMulti={false}
                                                            closeMenuOnSelect={true}
                                                            hideSelectedOptions={false}
                                                            isClearable
                                                            // menuShouldBlockScroll={false}
                                                            components={{
                                                                Option: (props) => {
                                                                    return <CustomOption {...props} />;  // Explicit return
                                                                },
                                                                Control: (props) => <CustomControl innerRef={props.innerRef} {...props} />
                                                            }}
                                                            onChange={handleStatementBankSelect}
                                                            allowSelectAll={true}
                                                            value={selectedBankId}
                                                            // menuIsOpen={menuIsOpen}
                                                            // onMenuOpen={handleMenuOpen}
                                                            // onMenuClose={handleMenuClose}
                                                            maxMenuHeight={150}
                                                            //onMenuOpen={handleMenuOpen}
                                                            // styles={{
                                                            //     // Target the selected option
                                                            //     option: (provided, state) => ({
                                                            //         ...provided,
                                                            //         backgroundColor: state.isSelected ? '#004C8F1A' : 'white', // Change the background color
                                                            //         color: state.isSelected ? '#212121' : '#212121',
                                                            //     }),
                                                            // }}
                                                            ref={selectRef}
                                                        />
                                                    </div>

                                                    {/* <div className={(isBankError === true) ? "input-div-err-style" : "input-div-style"}>
                                                            <select className="input-style" style={inputStyle} value={institutionId} name='setUserName' onChange={handleBankSelect} required>
                                                                <option value="-1">Select bank</option>
                                                                {bankList.map((item) => {
                                                                    return <option key={item.id} value={item.id}>{item.name}</option>
                                                                })}
                                                            </select>
                                                            <div className="float-right-icon">
                                                                <img src={getDropDownIconPath()} className="homeDropdownIcon" alt="dropdown" />
                                                            </div>
                                                        </div> */}

                                                    {/* <CustomDropdown
                                                            options={bankList}
                                                            title={"Select a bank"}
                                                            onChange={(selectedOption) => handleStatementBankSelect(0, selectedOption)}
                                                        /> */}
                                                </div> :
                                                <div>
                                                    <div style={{ marginBottom: '10px' }}>
                                                        <span className="homeTextFieldTitle" style={(isBankError === true) ? errorMsgStyle : fontMedium}>{bankHint}</span>
                                                    </div>
                                                    <div style={{ position: 'relative' }}>
                                                        <select className="action-input-style" style={inputStyle} value={institutionId} name='setUserName' onChange={handleBankSelect} required>
                                                            <option value="-1">Select bank</option>
                                                            {bankList.map((item) => {
                                                                return <option key={item.id} value={item.id}>{item.name}</option>
                                                            })}
                                                        </select>
                                                        <div className="float-right-icon">
                                                            <img src={getDropDownIconPath()} className="homeDropdownIcon" alt="dropdown" />
                                                        </div>
                                                    </div>
                                                </div> : <></>
                                }
                            </div>
                            {
                                ((!isNullOrEmpty(note)) && (bankName != note)) ?
                                    <div>
                                        <span className="institution_note_heading" style={fontBold}>Note : </span>
                                        <span className="institution_note" style={fontBold}>{note}</span>
                                    </div>
                                    : null
                            }
                            {
                                (isBankError === true) ?
                                    <span className="error-msg" style={errorMsgStyle}>{bankErr}</span> : null
                            }
                        </div>


                        <div>

                            <div style={{ paddingTop: '20px' }}>
                                <h4 className="instructionTitle" style={fontMedium}>Instructions</h4>
                                <ul className="instructionText" style={fontRegular}>
                                    <li style={liStyle}><span>Please upload the full months Statement of your {bankName} account </span>
                                        {
                                            (startMonth == endMonth) ? <span> for the month of {startMonth}</span> : <span> from {startMonth} to {endMonth}</span>
                                        }
                                        , Please ensure you have the same before proceeding</li>
                                    <li style={liStyle}>Upload the statements sent to you by the bank as it is</li>
                                    <li style={liStyle}>Statements should be in pdf format</li>
                                    <li style={liStyle}>Do NOT Create PDF statements from photos of Bank Statements</li>
                                </ul>
                            </div>
                            <div style={{ paddingTop: '20px' }}>
                                <span className="termsStyle" style={fontMedium}>{getTCText()}</span><span onClick={showTcFunc} className="tcStyle" style={fontMedium}>T & C</span>
                            </div>
                            <br />
                            {
                                (getUserActionBtnStyle() == userActionBtnStyleText) ?
                                    <div className="bottomTextDiv" style={bottomDivStyle}>
                                        <button className='full-primary-button' style={primaryButtonTheme} onClick={handleNext}>{getHomePrimaryBtnText()}</button>
                                        <div className="cancel-btn-div">
                                            <span className="cancel-btn-text" style={fontMedium} onClick={handleCancel}>{btnCancel}</span>
                                        </div>
                                    </div>
                                    :
                                    <div>
                                        <button className="error-button" style={secondaryButtonTheme} onClick={handleCancel}>{btnCancel}</button>
                                        <button className="primary-button" style={primaryButtonTheme} onClick={handleNext}>{getHomePrimaryBtnText()}</button>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
                {
                    (showTc === true) ?
                        <div className='popup' style={fontRegular}>
                            <div className='popup_inner' style={popupStyle}>
                                <div className="popup_header" style={popupStyle}>
                                    <img src={getCloseIconPath()} className="close-icon" onClick={hideTcFunc} alt="close" />
                                    <h5 style={fontBold}>{termsTitle}</h5>
                                </div>
                                <Terms />
                            </div>
                        </div> : null
                }
                {
                    (showPopup == true) ?
                        <PopUp
                            onPrimaryBtnClick={handleConfirm}
                            primaryBtnText="Ok"
                            titleText="Note"
                            bodyText={ReactHtmlParser(msgText)} /> : null}
            </div>
        </div>
    );
};

export default withRouter(StmtUploadHome);